// GFF Hero - licznik odliczający do startu wydarzenia
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var box = document.querySelector('[data-countdown]');
    if (!box) return;

    // format "RRRR-MM-DD GG:MM" parsowany jako czas lokalny
    var raw = box.getAttribute('data-countdown').trim();
    var m = raw.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
    if (!m) return;
    var target = new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], 0);

    var daysEl = box.querySelector('[data-countdown-days]');
    var daysLabelEl = box.querySelector('[data-countdown-days-label]');
    var hoursEl = box.querySelector('[data-countdown-hours]');
    var minutesEl = box.querySelector('[data-countdown-minutes]');
    var secondsEl = box.querySelector('[data-countdown-seconds]');

    function daysWord(n) {
      return n === 1 ? 'dzień' : 'dni';
    }

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function tick() {
      var diff = Math.floor((target - new Date()) / 1000);
      if (diff <= 0) {
        box.setAttribute('hidden', '');
        clearInterval(timer);
        return;
      }
      var days = Math.floor(diff / 86400);
      var hours = Math.floor((diff % 86400) / 3600);
      var minutes = Math.floor((diff % 3600) / 60);
      var seconds = diff % 60;

      daysEl.textContent = days;
      daysLabelEl.textContent = daysWord(days);
      hoursEl.textContent = pad(hours);
      minutesEl.textContent = pad(minutes);
      secondsEl.textContent = pad(seconds);
      box.removeAttribute('hidden');
    }

    var timer = setInterval(tick, 1000);
    tick();
  });
})();
